import { MediaAnalyticsCsvQuery } from './Media.codegen'
import { t } from '@lingui/macro'

export const prepareCSVMediaExport = (
  data: MediaAnalyticsCsvQuery['analytics']['media']['mediaOverview']
) =>
  data &&
  data[0].items.map((row) => {
    return {
      [t`File ID`]: row.id,
      [t`File name`]: row.fileName,
      [t`Resource name`]: row.resourceName,
      [t`Average engagement`]: row.avgEngagement,
      [t`Plays count`]: row.playsCount,
      [t`Impressions count`]: row.impressionsCount,
      [t`Play rate`]: row.playRate,
      [t`Unique play rate`]:
        row.uniqueImpressionsCount > 0
          ? row.uniquePlaysCount / row.uniqueImpressionsCount
          : 0,
      [t`Total play time minutes`]: row.totalPlayTimeMinutes,
      [t`Unique plays count`]: row.uniquePlaysCount || 0,
      [t`Unique impressions count`]: row.uniqueImpressionsCount,
      [t`Media deleted at`]: row.deletedAt,
      [t`Media uploaded at`]: row.createdAt,
      [t`Media last activity`]: row.lastActivity,
      [t`Resource deleted at`]: row.resourceDeletedAt
    }
  })
